export type Token = string


export class TokenCreationError {
  errorMessage: string

  constructor(errorMessage: string) {
    this.errorMessage = errorMessage
  }
}


export type CreateTokenResponse = Token | TokenCreationError

type MollieResponse = {
  token?: Token
  error?: unknown
}

type MollieTokenResponse = {
  token: Token
}

type MollieErrorResponse = {
  error: unknown
}

export const parseMollieResponse = (response: MollieResponse): CreateTokenResponse => {
  if (isTokenResponse(response)) {
    return response.token
  }

  if (isErrorResponse(response)) {
    console.warn('mollie returned an error during createToken:', response.error)
    return new TokenCreationError('token creation failed')
  }

  console.warn('error parsing mollie response for:', response)
  return new TokenCreationError('could not parse mollie response')
}

const isTokenResponse = (response: MollieResponse): response is MollieTokenResponse => {
  return response.token !== undefined
}

const isErrorResponse = (response: MollieResponse): response is MollieErrorResponse => {
  return response.error !== undefined
}
